import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function MarqueeBanner() {
  const { t } = useTranslation();
  const { marquee } = useSiteSettings();

  if (!marquee.enabled) return null;

  const text = marquee.text || t("banner.text");

  const chunk = (
    <span className="flex items-center">
      {[0, 1, 2, 3, 4, 5].map((n) => (
        <span key={n} className="mx-6 flex items-center gap-2 whitespace-nowrap">
          <i className="ri-fire-line"></i>
          <span className="text-xs md:text-sm font-semibold uppercase tracking-wide">{text}</span>
        </span>
      ))}
    </span>
  );

  return (
    <div className="w-full overflow-hidden bg-brand-gold text-brand-dark">
      <div className="flex w-max animate-marquee py-2.5">
        {chunk}
        {chunk}
      </div>
    </div>
  );
}